import {
  QueryClient,
  QueryClientProvider as BaseQueryClientProvider
} from '@tanstack/react-query'
import { PropsWithChildren } from 'react'

export const QueryClientProvider = ({ children }: PropsWithChildren) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false
      }
    }
  })

  return (
    <BaseQueryClientProvider client={queryClient}>
      {children}
    </BaseQueryClientProvider>
  )
}
